import { useCallback, useEffect, useRef } from 'react'
import { Platform } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { useAgentDetailsWF } from '@zet/customer/src/api/hooks/webFlow'

interface IScreenViewEventWrapper {
  screenName: string
  children?: React.ReactNode
  eventPayload?: object
}
export default function ScreenViewEventWrapper({
  children,
  screenName,
  eventPayload,
}: IScreenViewEventWrapper) {
  const userId = useRef({})
  const { data } = useAgentDetailsWF()
  if (Platform.OS === 'web') {
    // userId.current = mixpanel?.get_distinct_id()
  }

  const triggerEvent = () => {
    publishEvent('screen_view', {
      screen_name: screenName,
      ...(eventPayload ? eventPayload : {}),
    })
  }

  useEffect(() => {
    if (Platform.OS === 'web' && userId.current === 'zet_default_user') {
      triggerEvent()
    }
  }, [])

  const triggerScreenEvent = useCallback(() => {
    if (
      Platform.OS === 'web' &&
      userId.current &&
      userId.current !== 'zet_default_user'
    ) {
      triggerEvent()
    }
  }, [userId.current, screenName, eventPayload])

  useEffect(() => {
    triggerScreenEvent()
  }, [data])

  return children
}
